import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const BaseballCatcher = ({ size = 2, className }: Props) => (
  <svg
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.46057 9.39826L9.16379 8.7955L9.96746 9.76146L8.93968 10.6347H6.32774L5.46997 9.59145L6.02636 6.42312L7.25506 5.37988H9.81291L10.5316 6.25311L9.42653 7.18815L8.96287 6.61631H7.7419L7.32461 6.97178L6.94595 9.10461L7.18551 9.39826H8.46057Z"
      fill="white"
    />
  </svg>
);
